import { render, staticRenderFns } from "./ProjectViewSidebarProgressCard.vue?vue&type=template&id=a88b3b0e&scoped=true"
import script from "./ProjectViewSidebarProgressCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarProgressCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarProgressCard.vue?vue&type=style&index=0&id=a88b3b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b3b0e",
  null
  
)

export default component.exports